var map = {
	"./decidim/avatar-multiuser.png": 5024,
	"./decidim/brands/facebook.svg": 3790,
	"./decidim/brands/google.svg": 3295,
	"./decidim/brands/twitter-x.svg": 8948,
	"./decidim/cc-badge.png": 3370,
	"./decidim/decidim-logo.svg": 1842,
	"./decidim/default-avatar.svg": 6302,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 1378,
	"./decidim/icons.svg": 5889,
	"./decidim/pattern.png": 8014,
	"./decidim/placeholder-card-g.svg": 8451,
	"./decidim/placeholder-card-l.svg": 5320,
	"./decidim/placeholder.jpg": 3935,
	"./decidim/remixicon.symbol.svg": 4407,
	"./decidim/vendor/social-share-button/douban.svg": 1382,
	"./decidim/vendor/social-share-button/email.svg": 9363,
	"./decidim/vendor/social-share-button/facebook.svg": 4965,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 975,
	"./decidim/vendor/social-share-button/hacker_news.svg": 6471,
	"./decidim/vendor/social-share-button/linkedin.svg": 9723,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 9460,
	"./decidim/vendor/social-share-button/pinterest.svg": 8677,
	"./decidim/vendor/social-share-button/reddit.svg": 2421,
	"./decidim/vendor/social-share-button/telegram.svg": 6060,
	"./decidim/vendor/social-share-button/tumblr.svg": 1635,
	"./decidim/vendor/social-share-button/twitter.svg": 5394,
	"./decidim/vendor/social-share-button/vkontakte.svg": 9724,
	"./decidim/vendor/social-share-button/wechat.svg": 6791,
	"./decidim/vendor/social-share-button/whatsapp.svg": 9335,
	"./decidim/vendor/social-share-button/x.svg": 8099,
	"./decidim/vendor/social-share-button/xing.svg": 2773
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6171;